var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLtkLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 304,
    height: 276,
    viewBox: "0 0 304 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M303.9 0.599976V275.4H0.100098V0.599976H41.1001V234.5H262.9V0.599976H303.9Z",
    fill: "#3C3C3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.5 209.5H66.5V0.599976H238.1V41.6H107.5V209.5Z",
    fill: "#3C3C3B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M238.4 168.5H133V209.5H238.4V168.5Z",
    fill: "#FF980F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLtkLight);
export default __webpack_public_path__ + "static/media/ltk-light.b327af425626f653f3306601e9c83748.svg";
export { ForwardRef as ReactComponent };